import React, { useEffect, useRef, useState } from 'react';
import { Button, Dialog, PlusOutlined } from '@fx-ui/fine-design';
import MsgTargetConfig from '../msg-target-config';
import { MessageChannel } from '../../interfaces';
import { platformIntl } from '../../../../constants';

interface IMsgTargetSetDialogProps {
    value?: Array<any>;
    type?: MessageChannel;
    visible?: boolean;
    onClose?: () => void;
    onOk?: (val: Array<any>, nameMap: any) => void;
}

const MAX_COUNT = 5;

const MsgTargetSetDialog: React.FC<IMsgTargetSetDialogProps> = (props) => {
    const { value = [], type = 'sms', visible, onClose, onOk } = props;
    const [selected, setSelected] = useState<Array<any>>([]);
    const [loading, setLoading] = useState(true);
    const configRef = useRef<any>();
    useEffect(() => {
        if (!visible) {
            setLoading(true);
        }
    }, [visible]);
    const renderFooter = () => {
        return (
            <Button
                style={{ padding: 0 }}
                type="text"
                icon={<PlusOutlined />}
                disabled={loading}
                onClick={() => {
                    if (configRef.current) {
                        configRef.current.addTarget();
                    }
                }}
            >
                {platformIntl.get('msg.target.add')}
            </Button>
        );
    };
    return (
        <Dialog
            className="fx-msg-target-set-dialog"
            visible={visible}
            width={600}
            height={508}
            title={platformIntl.get('msg.target.modify')}
            separator={{ footer: false }}
            onCancel={() => onClose && onClose()}
            text4Cancel={platformIntl.get('cancel')}
            text4Ok={platformIntl.get('ok') + '(' + selected.length + '/' + MAX_COUNT + ')'}
            props4Ok={{
                loadingWhenClick: true,
                type: 'primary',
                disabled: loading || selected.length > MAX_COUNT
            }}
            onOk={() => onOk && onOk(selected, configRef.current && configRef.current.getNameMap())}
            footer={renderFooter()}
        >
            <MsgTargetConfig
                ref={configRef}
                value={value}
                type={type}
                multiSelect
                onChange={(val: Array<any>) => setSelected(val)}
                onGetTargets={(val: Array<any>) => {
                    setLoading(false);
                    setSelected(val);
                }}
                height={370}
            />
        </Dialog>
    );
};

export default MsgTargetSetDialog;
